import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

import translationEnglish from "public/locales/en/common.json";
import translationHindi from "public/locales/hi/common.json";
import translationGujarati from "public/locales/gu/common.json";
import translationMarathi from "public/locales/mr/common.json";
import translationTamil from "public/locales/ta/common.json";
import translationKannada from "public/locales/kn/common.json";

const resources = {
  en: {
    translation: translationEnglish,
  },
  hi: {
    translation: translationHindi,
  },
  gu: {
    translation: translationGujarati,
  },
  mr: {
    translation: translationMarathi,
  },
  ta: {
    translation: translationTamil,
  },
  kn: {
    translation: translationKannada,
  },
};

!i18n.isInitialized &&
  i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      resources,
      // lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
      // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
      // if you're using a language detector, do not define the lng option
      supportedLngs: ["en", "hi", "gu", "mr", "ta", "kn"],
      fallbackLng: "en",
      debug: true,
      detection: {
        // order and from where user language should be detected
        order: [
          "querystring",
          "navigator",
          "cookie",
          "localStorage",
          "sessionStorage",
          "htmlTag",
          "path",
          "subdomain",
        ],

        // keys or params to lookup language from
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,

        // cache user language on
        caches: ["localStorage", "cookie"],
        excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

        // optional expire and domain for set cookie
        cookieMinutes: 10,
        cookieDomain: "myDomain",

        // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
        cookieOptions: { path: "/", sameSite: "strict" },
      },
      interpolation: {
        escapeValue: false, // react already safe from xss attack
      },
    });

export default i18n;
